module.exports = __webpack_public_path__ + "img/2ad0c4e.jpg";